import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncToppleTriggers = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/dev/ToppleTriggers'
    componentImport={async () => (await import('src/pages/dev/ToppleTriggers'))}
    {...props}
  />
);
